// Copyright (c) 2025 Deere & Company

import Dealer, { getDefaultState as getDealerDefaultState } from '../../../../sharedmodules/state/dealer';
import t from 'tcomb';

const DuplicatePINPlateSearch = t.struct({
    approvedBy: t.maybe(t.String),
    approvedRemark: t.maybe(t.String),
    createdBy: t.maybe(t.String),
    dateSubmmited: t.maybe(t.Number),
    dealer: Dealer,
    factoryCode: t.maybe(t.String),
    factoryName: t.maybe(t.String),
    id: t.maybe(t.String),
    instruction: t.maybe(t.String),
    machineModel: t.maybe(t.String),
    mailingRecipient: t.maybe(t.String),
    missingPlateReason: t.maybe(t.String),
    pin: t.maybe(t.String),
    requesterTCSM: t.maybe(t.String),
    shippingId: t.maybe(t.String),
    status: t.maybe(t.String),
    updatedTs: t.maybe(t.Number),

}, 'DuplicatePINPlateSearch');

export const getDefaultState = () => new DuplicatePINPlateSearch({
    approvedBy: '',
    approvedRemark: '',
    createdBy: '',
    dateSubmmited: null,
    dealer: getDealerDefaultState(),
    factoryCode: '',
    factoryName: '',
    id: '',
    instruction: '',
    machineModel: '',
    mailingRecipient: '',
    missingPlateReason: '',
    pin: '',
    requesterTCSM: '',
    shippingId: '',
    status: '',
    updatedTs: null,

});

export default DuplicatePINPlateSearch;
